import { render, staticRenderFns } from "./DevBpbjInfoModal.Style#Drawer.vue?vue&type=template&id=1449837b&scoped=true&"
import script from "./DevBpbjInfoModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DevBpbjInfoModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjInfoModal.Style#Drawer.vue?vue&type=style&index=0&id=1449837b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1449837b",
  null
  
)

export default component.exports